import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Увы, но тут пусто ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_FailureBanner = _resolveComponent("FailureBanner")!
  const _component_EntityList = _resolveComponent("EntityList")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.page)
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Spinner, {
          key: 0,
          class: _normalizeClass(_ctx.$style.spinner)
        }, null, 8, ["class"]))
      : (_ctx.isNotFound)
        ? (_openBlock(), _createBlock(_component_FailureBanner, {
            key: 1,
            class: _normalizeClass(_ctx.$style.notFound)
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["class"]))
        : (_openBlock(), _createBlock(_component_EntityList, {
            key: 2,
            class: _normalizeClass(_ctx.$style.entities),
            entities: _ctx.childrenSorted
          }, null, 8, ["class", "entities"]))
  ], 2))
}